import { apiClient } from '@/shared/services/api/client'

interface ApiResponseEnvelope<T> {
  success: boolean
  message?: string
  data?: T
}

export interface NewsletterSubscribePayload {
  email: string
  /** Page identifier: home, about, help, my-esim, download — optional */
  source?: string
}

export interface NewsletterSubscribeResult {
  message: string
  alreadySubscribed: boolean
  newSubscription: boolean
  reactivated: boolean
}

/**
 * POST /api/v1/marketing/newsletter/subscribe — public (no API key).
 */
export async function subscribeNewsletter(payload: NewsletterSubscribePayload): Promise<NewsletterSubscribeResult> {
  const body: { email: string; source?: string } = { email: payload.email.trim() }
  if (payload.source?.trim()) {
    body.source = payload.source.trim()
  }
  const res = await apiClient.post<
    ApiResponseEnvelope<{
      alreadySubscribed: boolean
      newSubscription: boolean
      reactivated: boolean
    }>
  >('/marketing/newsletter/subscribe', body)
  const d = res.data
  return {
    message: res.message || "You're subscribed.",
    alreadySubscribed: d?.alreadySubscribed ?? false,
    newSubscription: d?.newSubscription ?? false,
    reactivated: d?.reactivated ?? false,
  }
}
